<template>
  <div class="content background1" style="display: flex">
    <div class="tableBox9" v-if="!qrCodeShow">
      <div class="tableMes">
        <div class="table">
          <el-tabs
            v-model="activeNameTree"
            type="card"
            @tab-click="handleClickTree"
          >
            <el-tab-pane :label="$t('label_429')" name="first" v-if="showTree">
              <tree
                :dataTree="treeData"
                :treeType="0"
                @getDeviceMes="getDeviceMes"
              ></tree>
            </el-tab-pane>
            <el-tab-pane :label="$t('label_161')" name="second" v-if="showTree">
              <tree
                :dataTree="treeData2"
                :treeType="1"
                @getDeviceMes="getDeviceMes"
              ></tree>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="right-showbtn" @click="showBtn">
      <div class="right-showbtn-qrcode-background">
        <i
          v-if="qrCodeShow"
          class="el-icon-arrow-right"
          style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"
        ></i>
        <i
          v-if="!qrCodeShow"
          class="el-icon-arrow-left"
          style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"
        ></i>
      </div>
    </div>
    <div
      class="tableBox10"
      :style="{
        padding: width == '0px' ? '60px 0px 0px 0px' : '60px 0px 0px 350px '
      }"
    >
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes == '1'">
            <p class="title">
              <span class="spot">{{
                deviceDetailMes.name != null
                  ? "<" + deviceDetailMes.name + ">"
                  : deviceDetailMes.name
              }}</span
              >{{ $t("label_750") }}
            </p>
            <div
              class="chooseBox spaceBetween"
              style="height: 100px;width: calc(100% - 180px); float: left;"
            >
              <div class="selectBox">
                <div>
                  <div class="selectChoose" style="width:240px">
                    <div class="selectText">
                      <p>{{ $t("label_593") }}</p>
                    </div>
                    <div class="select" style="width:220px">
                      <el-input v-model="eqName" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose" style="width: 240px">
                    <div class="selectText">
                      <p>{{ $t("label_194") }}</p>
                    </div>
                    <div class="select" style="width:220px">
                      <el-input v-model="code" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div style="width: 50%;">
                  <div class="selectChoose" style="width: 100%;">
                    <div class="selectText" style="width: 24%;">
                      <p>{{ $t("label_752") }}</p>
                    </div>
                    <div class="select timeRadio" style="width:350px">
                      <el-radio-group
                        v-model="checkTime"
                        @change="checkTimebtn"
                      >
                        <el-radio-button label="0">{{
                          $t("label_599")
                        }}</el-radio-button>
                        <el-radio-button label="1">{{
                          $t("label_743")
                        }}</el-radio-button>
                        <el-radio-button label="2">{{
                          $t("label_542")
                        }}</el-radio-button>
                        <el-radio-button label="3">{{
                          $t("label_540")
                        }}</el-radio-button>
                      </el-radio-group>
                    </div>
                    <div class="select" style="width:350px">
                      <el-date-picker
                        v-if="checkTime == 0"
                        v-model="Readytime"
                        :editable="false"
                        :clearable="true"
                        @clear="clearAllTime"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        :range-separator="$t('label_264')"
                        :start-placeholder="$t('label_329')"
                        :end-placeholder="$t('label_388')"
                        key="daterange"
                      >
                      </el-date-picker>
                      <el-date-picker
                        v-if="checkTime == 1"
                        v-model="Readytime1"
                        :editable="false"
                        :clearable="true"
                        @clear="clearAllTime"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="week"
                        @change="changeTime"
                        :picker-options="{ firstDayOfWeek: 1 }"
                      >
                      </el-date-picker>
                      <el-date-picker
                        v-if="checkTime == 2"
                        v-model="Readytime1"
                        :editable="false"
                        :clearable="true"
                        @clear="clearAllTime"
                        format="yyyy-MM"
                        value-format="yyyy-MM-dd"
                        type="month"
                        @change="changeTime"
                      >
                      </el-date-picker>
                      <el-date-picker
                        v-if="checkTime == 3"
                        v-model="Readytime1"
                        :editable="false"
                        :clearable="true"
                        @clear="clearAllTime"
                        format="yyyy"
                        value-format="yyyy-MM-dd"
                        type="year"
                        @change="changeTime"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
                <!--								<div>-->
                <!--									<div class="selectChoose" style="width: 280px">-->
                <!--										<div class="selectText" style="width: 140px;">-->
                <!--											<p>{{$t('label_602')}}</p>-->
                <!--										</div>-->
                <!--										<div class="select" style="width:220px">-->
                <!--											<el-select v-model="checkStatus" :disabled="checkFlag" clearable>-->
                <!--												<el-option v-for="item in checkStatu		sOptions" :key="item.value" :label="item.label" :value="item.value">-->
                <!--												</el-option>-->
                <!--											</el-select>-->
                <!--										</div>-->
                <!--									</div>-->
                <!--								</div>-->
                <div
                  class="buttonBox buttonBoxRight"
                  style="width: 150px; float: left;right: -150px"
                >
                  <div>
                    <div
                      class="chooseButton sendButton"
                      @click="search({ pageNum: 1, pageSize: pageSize })"
                    >
                      <i class="el-icon-search"></i>{{ $t("btn_2") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div> -->
            <div class="spotStatusNumList" style="padding: 0 16px;">
              <div
                class="statusMesBox"
                v-for="(item, index) in spotStatusNumList"
                :class="item.check == true ? 'check' : ''"
              >
                <div class="iconBox" :style="{ background: item.color }">
                  <i :class="item.icon"></i>
                </div>
                <div class="textBox">
                  <p>{{ item.text }}</p>
                  <p class="num" :style="{ color: item.color }">
                    {{ item.num }}
                  </p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="item.check"></el-checkbox>
                </div>
              </div>
              <strong></strong>
            </div>
            <div class="spotMes2Box">
              <div class="buttonBox" style="margin-left: -2px;">
                <div>
                  <div
                    class="chooseButton searchButton"
                    style="margin-right: 5px;"
                    @click="checkResults"
                    v-if="MenuRoleList.indexOf('70') >= 0"
                  >
                    {{ $t("label_749") }}
                  </div>
                  <!-- <div class="chooseButton searchButton" style="width: 100px;" @click="saveRemark()" v-if="MenuRoleList.indexOf('188')>=0">{{$t('btn_29')}}</div> -->
                </div>
                <div>
                  <div
                    class="chooseButton searchButton"
                    style="margin-right: 5px;"
                    @click="download()"
                    v-if="MenuRoleList.indexOf('70') >= 0"
                  >
                    <i class="el-icon-download"></i>{{ $t("label_947") }}
                  </div>
                </div>
                <!--								<div v-if="MenuRoleList.indexOf('182')>=0" style="margin-left: 4px;">-->
                <!--									<div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;" @click="checkBack(1)">{{$t('btn_62')}}</div>-->
                <!--									<div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;" @click="check(1)">{{$t('btn_31')}}</div>-->
                <!--									&lt;!&ndash; <div v-else class="chooseButton searchButton" style="width: 100px;" @click="checkOff">{{$t('btn_30')}}</div> &ndash;&gt;-->
                <!--								</div>-->
                <!--								<div v-if="MenuRoleList.indexOf('183')>=0" style="margin-left: 4px;">-->
                <!--									<div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;" @click="checkBack(2)">{{$t('btn_61')}}</div>-->
                <!--									<div v-if="!checkFlag" class="chooseButton searchButton" style="width: 100px;" @click="check(2)">{{$t('btn_32')}}</div>-->
                <!--									&lt;!&ndash; <div v-else class="chooseButton searchButton" style="width: 100px;" @click="checkOff">{{$t('btn_30')}}</div> &ndash;&gt;-->
                <!--								</div>-->
                <div v-if="checkFlag">
                  <div
                    class="chooseButton searchButton"
                    style="width: 100px;"
                    @click="checkOff"
                  >
                    {{ $t("btn_35") }}
                  </div>
                  <div
                    class="chooseButton searchButton"
                    style="width: 100px;"
                    @click="checkOne"
                  >
                    {{ $t("label_158") }}
                  </div>
                  <div
                    class="chooseButton searchButton"
                    style="width: 100px;"
                    @click="checkAll"
                  >
                    {{ $t("btn_34") }}
                  </div>
                </div>
                <div
                  v-if="$store.getters.getVersions == 4"
                  style="margin-right: 1px;"
                >
                  <div
                    class="chooseButton searchButton"
                    style="width: 140px;"
                    @click="checkAllExportExcel"
                  >
                    <i class="el-icon-download"></i>{{ $t("btn_10") }}
                  </div>
                </div>
              </div>

              <div class="tableMin" style="height: calc(100% - 50px)">
                <el-table
                  :empty-text="$t('label_357')"
                  ref="singleTable"
                  :data="tableDataTreeTime"
                  highlight-current-row
                  @current-change="handleCurrentChangeTreeTime"
                  border
                  height="90%"
                  style="width: 100%;margin:10px 0 10px 0;"
                  :header-cell-style="{
                    'background-color': '#45494f',
                    color: '#ffffff'
                  }"
                  @row-click="handler"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    :label="$t('label_369') + '.'"
                    type="index"
                    :index="getIndex"
                    width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$t('label_593')"
                    align="center"
                    width="380"
                  >
                    <template slot-scope="scope">
                      <p class="tableMiTitle">
                        {{ scope.row.superior }}<br />
                        {{ scope.row.etname }} {{ scope.row.ename }} <br />
                        {{ scope.row.code }}<br />
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="beginTime"
                    :label="$t('label_745')"
                    align="center"
                    width="110"
                  >
                    <template slot-scope="scope">
                      <p>{{ scope.row.beginTime.split(" ")[0] }}</p>
                      <p>{{ scope.row.beginTime.split(" ")[1] }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="checkBeginTime"
                    :label="$t('label_746')"
                    align="center"
                    width="110"
                  >
                    <template slot-scope="scope">
                      <p v-if="scope.row.checkBeginTime == null">--</p>
                      <p v-if="scope.row.checkBeginTime != null">
                        {{ scope.row.checkBeginTime.split(" ")[0] }}
                      </p>
                      <p v-if="scope.row.checkBeginTime != null">
                        {{ scope.row.checkBeginTime.split(" ")[1] }}
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="endTime"
                    :label="$t('label_946')"
                    align="center"
                    width="110"
                  >
                    <template slot-scope="scope">
                      <p>{{ scope.row.endTime.split(" ")[0] }}</p>
                      <p>{{ scope.row.endTime.split(" ")[1] }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="checkUserName"
                    :label="$t('label_747')"
                    align="center"
                    width="100"
                  >
                    <template slot-scope="scope">
                      <p v-if="scope.row.checkUserName == null">--</p>
                      <p v-if="scope.row.checkUserName != null">
                        {{ scope.row.checkUserName }}
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="status"
                    :label="$t('label_748')"
                    align="center"
                    width="80"
                  >
                    <template slot-scope="scope">
                      <p
                        :style="{
                          color: spotStatusNumList[scope.row.status].color
                        }"
                      >
                        {{ spotStatusNumList[scope.row.status].text }}
                      </p>
                    </template>
                  </el-table-column>
                  <!--									<el-table-column prop="checkStatus" :label="$t('btn_31') + $t('label_412')" align="center" width="110">-->
                  <!--										<template slot-scope="scope">-->
                  <!--											<p :style="{'color':scope.row.checkStatus>1?'#0353c1':'#ffb400'}">{{scope.row.checkStatus>1?$t('label_258'):$t('label_254')}}</p>-->
                  <!--											<p v-if="scope.row.checkStatus>1">{{scope.row.monitorUser}}</p>-->
                  <!--											<p v-if="scope.row.monitorTime!=null">{{scope.row.monitorTime.split(' ')[0]}}</p>-->
                  <!--											<p v-if="scope.row.monitorTime!=null">{{scope.row.monitorTime.split(' ')[1]}}</p>-->
                  <!--										</template>-->
                  <!--									</el-table-column>-->
                  <!--									<el-table-column prop="checkStatus" :label="$t('btn_32') + $t('label_412')" align="center" width="110">-->
                  <!--										<template slot-scope="scope">-->
                  <!--											<p :style="{'color':scope.row.checkStatus==3?'#0353c1':'#ffb400'}">{{scope.row.checkStatus==3?$t('label_258'):$t('label_254')}}</p>-->
                  <!--											<p v-if="scope.row.checkStatus==3">{{scope.row.supervisorUser}}</p>-->
                  <!--											<p v-if="scope.row.supervisorTime!=null">{{scope.row.supervisorTime.split(' ')[0]}}</p>-->
                  <!--											<p v-if="scope.row.supervisorTime!=null">{{scope.row.supervisorTime.split(' ')[1]}}</p>-->
                  <!--										</template>-->
                  <!--									</el-table-column>-->
                  <el-table-column
                    prop="remark"
                    :label="$t('btn_29')"
                    align="center"
                  ></el-table-column>
                </el-table>
                <Page
                  class="item"
                  ref="pageModel"
                  :total="pageCount"
                  :display="pageSize"
                  :pagegroup="3"
                  :currentspage="1"
                  @parentMethod="search"
                  v-show="!checkFlag"
                ></Page>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('label_749')"
      :visible.sync="dialogSpotResult"
      append-to-body
      :close-on-click-modal="false"
      width="1100px"
      top="7%"
      :before-close="handleClose"
      custom-class="dialogBox"
    >
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="titleMes">
          <p>
            {{ tableDataTree.superior }}<br />
            {{ tableDataTree.etname }} {{ tableDataTree.ename }}
            {{ tableDataTree.code }}
          </p>
          <p>{{ $t("label_747") }}：{{ tableDataTree.checkUserName }}</p>
          <!-- 新增发邮件按钮区域 -->
          <div
            style="padding: 0 20px 15px; display: flex; justify-content: flex-end;"
          >
            <el-button
              type="primary"
              icon="el-icon-message"
              @click="sendEmail"
              :disabled="selectedIds.length === 0"
              >{{ $t("label_1000") }}</el-button
            >
          </div>
        </div>

        <div class="proSpotMes">
          <div class="proMes">
            <div class="proP">
              <p v-bind:style="styleObject4">
                {{
                  tableDataTree.checkBeginTime == null
                    ? ""
                    : tableDataTree.checkBeginTime
                }}
              </p>
              <p v-bind:style="styleObject5">
                {{
                  tableDataTree.checkEndTime == null
                    ? ""
                    : tableDataTree.checkEndTime
                }}
              </p>
            </div>
            <div class="proTime">
              <p v-bind:style="styleObject1"></p>
              <p v-bind:style="styleObject2"></p>
              <p v-bind:style="styleObject3"></p>
            </div>
            <div class="proUp">
              <p v-bind:style="styleObject6">
                {{
                  tableDataTree.beginTime == null ? "" : tableDataTree.beginTime
                }}
              </p>
              <p v-bind:style="styleObject7">
                {{ tableDataTree.endTime == null ? "" : tableDataTree.endTime }}
              </p>
            </div>
          </div>
          <div class="proText">
            <p>
              {{ $t("label_746") }}
              <span class="real">{{ tableDataTree.checkDuration }}</span
              >{{ $t("label_647") }}
            </p>
            <p>
              <i class="cricleIcon" style="background: #3fb393"></i
              >{{ $t("label_580") }}
              {{
                tableDataTree.checkBeginTime == null
                  ? ""
                  : tableDataTree.checkBeginTime
              }}
            </p>
            <p>
              <i class="cricleIcon" style="background: #3fb393"></i
              >{{ $t("label_585") }}
              {{
                tableDataTree.checkEndTime == null
                  ? ""
                  : tableDataTree.checkEndTime
              }}
            </p>
            <p>
              {{ $t("label_745") }}
              <span class="plan">{{ tableDataTree.duration }}</span
              >{{ $t("label_647") }}
            </p>
            <p>
              <i class="cricleIcon" style="background: #0353c1"></i
              >{{ $t("label_580") }}
              {{
                tableDataTree.beginTime == null ? "" : tableDataTree.beginTime
              }}
            </p>
            <p>
              <i class="cricleIcon" style="background: #0353c1"></i
              >{{ $t("label_585") }}
              {{ tableDataTree.endTime == null ? "" : tableDataTree.endTime }}
            </p>
          </div>
        </div>
        <el-table
          :empty-text="$t('label_357')"
          ref="singleTable"
          :data="tableDataTree.list"
          highlight-current-row
          @current-change="handleCurrentChangeTree"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%;"
          height="400px"
          :header-cell-style="{
            'background-color': '#45494f',
            color: '#ffffff'
          }"
        >
          <!-- 新增选择框列 -->
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            :label="$t('label_369') + '.'"
            type="index"
            width="50"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('label_533')"
            align="left"
            width="220"
          >
            <template slot-scope="scope">
              {{ scope.row.name }}
              <br />
              <popMesBox
                :popMes="scope.row.content"
                :hoverMes="scope.row.content"
                :popWidth="200"
              ></popMesBox>
            </template>
          </el-table-column>
          <el-table-column
            prop="cycleType"
            :label="$t('label_741')"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.cycleType == '1'">{{
                scope.row.cycle == "0"
                  ? $t("label_652")
                  : $t("label_531") + scope.row.cycle + $t("label_537")
              }}</template>
              <template v-if="scope.row.cycleType == '2'">{{
                scope.row.cycle == 0
                  ? weekendMesOptions[6].label
                  : weekendMesOptions[scope.row.cycle - 1].label
              }}</template>
              <template v-if="scope.row.cycleType == '3'">{{
                scope.row.cycle > 20
                  ? $t("label_238") + scope.row.cycle + $t("label_537")
                  : scope.row.cycle > 10
                  ? $t("label_242") + scope.row.cycle + $t("label_537")
                  : $t("label_245") + scope.row.cycle + $t("label_537")
              }}</template>
              <template v-if="scope.row.cycleType == '8'">{{
                $t("label_531") + scope.row.cycle + $t("label_743")
              }}</template>
              <template v-if="scope.row.cycleType == '9'">{{
                $t("label_531") + scope.row.cycle + $t("label_542")
              }}</template>
            </template>
          </el-table-column>
          <el-table-column
            prop="method"
            :label="$t('label_742')"
            align="center"
          >
            <template slot-scope="scope">
              {{ checkText(scope.row.method) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="defaultValue"
            :label="$t('label_368')"
            align="center"
          >
            <template slot-scope="scope">
              {{
                checkDefaultValue(scope.row.defaultValue, scope.row.inputType)
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="checkResult"
            :label="$t('label_749')"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="photo"
            :label="$t('label_865')"
            align="center"
            width="200px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.photo != null && scope.row.photo != ''">
                <span
                  v-if="scope.row.photo != null && scope.row.photo != ''"
                  v-for="item in scope.row.photo.split(',')"
                  style="border: 1px solid #dedede;display: inline-block;padding: 8px 5px 0 5px"
                >
                  <img
                    style="width: 30px;height: 30px;"
                    :src="
                      $store.getters.getPostUrl + 'mes/sysFile/download/' + item
                    "
                    @click="show(item, 'photo')"
                  />
                </span>
              </span>
              <span v-if="scope.row.video != null && scope.row.video != ''">
                <span
                  v-if="scope.row.video != null && scope.row.video != ''"
                  v-for="item in scope.row.video.split(',')"
                  style="border: 1px solid #dedede;display: inline-block;padding: 8px 5px 0 5px"
                >
                  <img
                    style="width: 30px;height: 30px;"
                    src="../../assets/img/spot/video.png"
                    @click="show(item, 'video')"
                  />
                </span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('label_251')"
      :visible.sync="dialogImg"
      append-to-body
      :close-on-click-modal="false"
      width="800px"
      id="dialogImg"
      top="10%"
      :before-close="closeImg"
      custom-class="dialogBox"
    >
      <div class="dialogBoxMes" style="padding:0 20px;">
        <img
          style="width: 100%;"
          :src="$store.getters.getPostUrl + 'mes/sysFile/download/' + img"
        />
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('label_248')"
      :visible.sync="dialogVideo"
      append-to-body
      :close-on-click-modal="false"
      width="800px"
      id="dialogVideo"
      top="10%"
      :before-close="closeImg"
      custom-class="dialogBox"
    >
      <div class="dialogBoxMes" style="padding:20px 20px;" v-if="dialogVideo">
        <video width="100%" height="500" controls autoplay="autoplay">
          <source
            :src="$store.getters.getPostUrl + 'mes/sysFile/download/' + img"
          />
        </video>
      </div>
    </el-dialog>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_29')"
      :visible.sync="dialogSpotRemark"
      append-to-body
      :close-on-click-modal="false"
      width="400px"
      top="20%"
      :before-close="handleClose"
      custom-class="dialogBox"
    >
      <div class="dialogMes">
        <p>{{ $t("btn_29") }}</p>
        <div class="mesInput">
          <el-input v-model="newType.remark"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="chooseButton sendButton" @click="newTypeSave">
          {{ $t("btn_13") }}
        </div>
      </span>
    </el-dialog>
    <!-- 邮件发送对话框 -->
    <el-dialog
      :title="$t('label_1000')"
      :visible.sync="emailDialogVisible"
      append-to-body
      width="800px"
      top="10%"
      custom-class="dialogBox"
    >
      <div class="email-dialog-content">
        <el-form :model="emailForm" label-width="100px">
          <el-form-item :label="$t('label_1018')">
            <el-input
              v-model="emailForm.emailTo"
              :placeholder="$t('msg_243')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('label_1019')">
            <el-input v-model="emailForm.subject"></el-input>
          </el-form-item>
          <!-- 核心：HTML内容显示区域（写死内容，直接渲染） -->
          <el-form-item :label="$t('内容')">
            <div
              class="email-html-content"
              style="border: 1px solid #e6e6e6; padding: 15px; min-height: 120px; line-height: 1.6;"
              v-html="dynamicHtmlContent"
            ></div>
          </el-form-item>
          <!-- <el-form-item :label="$t('label_1022')">
            <el-input v-model="emailForm.emailText"></el-input>
          </el-form-item> -->
          <el-form-item :label="$t('label_1022')">
            <el-input
              type="textarea"
              :rows="5"
              v-model="emailForm.emailText"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="emailDialogVisible = false">{{
          $t("btn_1")
        }}</el-button>
        <el-button
          type="primary"
          @click="submitCheckEmail"
          :loading="emailSending"
          >{{ $t("btn_70") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css";
import "@/assets/css/common/spot.css";
import Page from "@/components/common/page";
import utils from "@/utils/utils";
import tree from "@/components/list/tree/checkTree";
import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
import file from "@/assets/js/file/file.js";
import popMesBox from "@/components/list/popover/pop";
import axios from "axios";
import spotCheck from "../../assets/js/spotCheck/spotCheck";
export default {
  name: "spotResumePage",
  components: {
    Page,
    tree,
    popMesBox
  },
  data() {
    return {
      // 新增：写死的HTML内容（URL直接固定，无需后端请求）
      fixedHtmlContent: `
      <div>
        <h3 style="color: #333; margin-bottom: 10px;">確認が必要な点検結果の表示</h3>
        <p style="margin: 8px 0;">詳細は次のリンクをクリックしてください：</p>
        <p style="margin: 8px 0;">
          リンクがクリックできない場合は、次のアドレスをブラウザにコピーしてください：<br>
        </p>

      </div>
    `,
      dynamicHtmlContent: '',
      saveLoading: false,
      pickerOptions1: {
        disabledDate(date) {
          let now = new Date();
          let nowTime = now.getTime();
          let day = now.getDay() == 0 ? 7 : now.getDay();
          let oneDayTime = 24 * 60 * 60 * 1000;
          // 上周日时间戳
          let MondayTime = nowTime - (7 - day) * oneDayTime;
          return date.getTime() > new Date(MondayTime);
        }
      },
      pickerOptions2: {
        disabledDate(date) {
          let now = new Date();
          return date.getTime() > now.setMonth(now.getMonth() - 1);
        }
      },
      // 用于存储选中行的ID
      selectedIds: [],
      checkFlag: false,
      checkUser: 0,
      checkTime: 0,
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      Readytime: [], 
      Readytime1: "",
      Readytime1_: "",
      Readytime2: "",
      errIds: [],
      eqName: "",
      code: "",
      checkStatus: 0,
      // 邮件发送相关
      emailDialogVisible: false,
      emailSending: false,
      spotCheckEmailUrl: "",
      emailForm: {
        emailTo: "",
        subject: "",
        fixedHtmlContent: "",
        emailText: ""
      },
      selectedItems: [],
      checkStatusOptions: [
        {
          label: this.$t("label_272"),
          value: 0
        },
        {
          label: this.$t("label_700"),
          value: 1
        },
        {
          label: this.$t("label_704"),
          value: 2
        },
        {
          label: this.$t("label_833"),
          value: 3
        }
      ],
      getTreeMes: "1",
      img: "",
      checked: false,
      dialogImg: false,
      dialogVideo: false,
      dialogSpotRemark: false,
      deviceDetailMes: {},
      dialogSpotResult: false,
      MenuRoleList: [],
      newType: {
        id: "",
        remark: ""
      },
      spotStatusNumList: [
        {
          icon: "el-icon-video-pause",
          text: this.$t("label_254"),
          check: true,
          num: "0",
          color: "#ffb400"
        },
        {
          icon: "el-icon-caret-right",
          text: this.$t("label_832"),
          check: true,
          num: "0",
          color: "#8a00ff"
        },
        {
          icon: "el-icon-check",
          text: this.$t("label_258"),
          check: true,
          num: "0",
          color: "#0353c1"
        },
        {
          icon: "el-icon-close",
          text: this.$t("label_261"),
          check: true,
          num: "0",
          color: "#e60000"
        },
        {
          icon: "el-icon-refresh-left",
          text: this.$t("label_265"),
          check: true,
          num: "0",
          color: "#3fb393"
        },
        {
          icon: "el-icon-video-pause",
          text: this.$t("label_777"),
          check: true,
          num: "0",
          color: "#cacaca"
        }
      ],
      tableDataTree: [],
      tableDataTreeInfo: [],
      tableDataInfo: {},
      typeName: "",
      deptName: "",
      treeData: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: "2"
      },
      treeData2: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: "3"
      },
      checkList: [],
      //weekendMesOptions: [this.$t('label_716'), this.$t('label_719'), this.$t('label_721'), this.$t('label_723'), this.$t('label_725'), this.$t('label_728'), this.$t('label_730')],
      weekendMesOptions: [
        {
          value: "1",
          label: this.$t("label_719")
        },
        {
          value: "2",
          label: this.$t("label_721")
        },
        {
          value: "3",
          label: this.$t("label_723")
        },
        {
          value: "4",
          label: this.$t("label_725")
        },
        {
          value: "5",
          label: this.$t("label_728")
        },
        {
          value: "6",
          label: this.$t("label_730")
        },
        {
          value: "0",
          label: this.$t("label_716")
        }
      ],
      monthDOptions: [],
      monthOptions: [
        this.$t("label_245"),
        this.$t("label_242"),
        this.$t("label_238")
      ],
      monthOptionsObj: {
        // '每月初': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        // '每月中': ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        // '每月末': ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      },
      tableDataTreeTime: [],
      selectedStatus: [],
      statusText: [
        {
          id: "0",
          text: this.$t("btn_36"),
          color: "#3fb393"
        },
        {
          id: "1",
          text: this.$t("btn_37"),
          color: "#fe0000"
        },
        {
          id: "2",
          text: this.$t("label_443"),
          color: "#ffb400"
        },
        {
          id: "3",
          text: this.$t("label_447"),
          color: "#000000"
        }
      ],
      activeNameTree: "second",
      status: "",

      styleObject1: {
        width: "0%"
      },
      styleObject2: {
        width: "100%",
        background: "#3fb393"
      },
      styleObject3: {
        width: "0%"
      },
      styleObject4: {
        width: "0%",
        "text-align": "right",
        "margin-right": "10px",
        "padding-left": "0%",
        "min-width": "150px"
      },
      styleObject5: {
        "padding-right": "0%",
        "min-width": "150px"
      },
      styleObject6: {
        // 'width': '0%',
        // 'text-align': 'right',
        // 'margin-right': '10px',
        // 'padding-right': '0%',
        // 'min-width': '150px'
        "padding-right": "0%",
        "min-width": "150px"
      },
      styleObject7: {
        "padding-right": "0%",
        "min-width": "150px"
      },
      width: "340px",
      qrCodeShow: false,
      showTree: true
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    clearAllTime() {
      this.Readytime = [];    // 清空「日」的时间数组
      this.Readytime1 = null;   // 清空「周/月/年」的时间字符串
      this.Readytime1_ = "";  // 清空冗余的时间变量
      this.Readytime2 = "";   // 清空冗余的时间变量
    },
    // 处理选择变化事件
    handleSelectionChange(selection) {
      // 从选中的行中提取ID
      this.selectedIds = selection.map(item => item.id);
      // this.selectedStatus = selection.map(item => item.status)
      // console.log(this.selectedStatus);
    },

    // 修改原来的 sendEmail 方法
    sendEmail() {
      if (this.selectedIds.length === 0) {
        this.$message.warning(this.$t('msg_4'));
        return;
      }
      // console.log('发送测试'+ this.tableDataTree.list)
      // // 2. 检查是否存在状态≠3的项（状态≠3即为“未点检”）
      // const hasUncheckedItem = this.tableDataTree.list.some(item => item.status !== 3);
      // // 3. 有未点检数据时提示并终止
      // if (hasUncheckedItem) {
      //   this.$message.warning(this.$t("不可以发送未点检的内容"));
      //   return;
      // }
      // 获取选中项的详细信息
      this.selectedItems = this.tableDataTree.list.filter(item =>
        this.selectedIds.includes(item.id)
      );
      // 1. 将选中的ID数组转换为逗号分隔的字符串
      const newIds = this.selectedIds.join(",");

      // 2. 进行Base64编码
      const encodeToString = btoa(unescape(encodeURIComponent(newIds)));

      // 3. 对Base64字符串进行URL编码
      const urlEncoded = encodeURIComponent(encodeToString);

      // 4. 构建完整的URL参数
      // const urlParam = `http://10.200.0.96:8080/spotCheckEmail?id=${urlEncoded}`;
      // const urlParam = `https://inbis-fms.com/spotCheckEmail?id=${urlEncoded}`;
      const urlParam = `https://inbis-fms.com/spotCheckEmail?id=${urlEncoded}`;
          // 5. 将完整URL嵌入到邮件HTML内容中
      const emailHtmlContent = `
       <div>
        <h3 style="color: #333; margin-bottom: 10px;">確認が必要な点検結果の表示</h3>
        <p style="margin: 8px 0;">詳細は次のリンクをクリックしてください：</p>
        <p style="margin: 8px 0;">
          リンクがクリックできない場合は、次のアドレスをブラウザにコピーしてください：<br>
        </p>
         <p style="margin: 8px 0;">
          <a href="${urlParam}" target="_blank" style="color: #0353c1; text-decoration: underline;">
            ${urlParam}
          </a>
         </p>
       </div>`;
      this.dynamicHtmlContent = emailHtmlContent;
      // 显示邮件对话框
      this.emailDialogVisible = true;
    },

    // 提交邮件
    submitCheckEmail() {
      if (!this.emailForm.emailTo) {
        this.$message.warning(this.$t('msg_243'));
        return;
      }

      this.emailSending = true;

      // 构造发送数据
      const emailData = {
        emailSend: this.emailForm.emailTo,
        subject: this.emailForm.subject,
        selectedIds: this.selectedIds,
        fixedHtmlContent: this.fixedHtmlContent,
        emailText: this.emailForm.emailText
      };

      // 调用后端接口发送邮件
      spotCheck
        .checkEmailSend(emailData)
        .then(response => {
          console.log("邮件发送响应:", response); // 调试日志
          if (response.status === 200) {
            this.$message.success(this.$t('msg_255'));
            // 清空表单
            this.emailForm = {
              emailTo: "",
              subject: "",
              emailText: ""
            };
            this.emailDialogVisible = false;
          } else {
            this.$message.error(
              this.$t('msg_195')
            );
          }
        })
        .catch(error => {
          this.$message.error(this.$t('msg_195'));
        })
        .finally(() => {
           this.emailForm = {
              emailTo: "",
              subject: "",
              emailText: ""
            };
          this.emailSending = false;
        });
    },

    // 生成默认邮件内容
    generateEmailContent() {
      let content = this.$t("您好，\n\n这是点检结果报告：\n\n");

      this.selectedItems.forEach((item, index) => {
        content += `${index + 1}. ${item.name}: ${item.checkResult}\n`;
      });

      content += "\n" + this.$t("谢谢！");
      return content;
    },
    reloadTree() {
      this.showTree = false;
      this.$nextTick(function() {
        this.showTree = true;
      });
    },
    checkTimebtn(val) {
        // ✅ 核心新增：切换时间类型时，先清空所有旧的时间值【关键】
        this.clearAllTime();

      let now = new Date();
      if (val == 0) {
        // this.Readytime = [this.getBeforeTime(), this.getNowTime()];
        this.Readytime = [];
      } else if (val == 1) {
        this.changeTime(
          now.getFullYear() +
            "-" +
            this.zero(now.getMonth() + 1) +
            "-" +
            this.zero(now.getDate())
        );
      } else if (val == 2) {
        let date = new Date(
          now.getFullYear() + "-" + this.zero(now.getMonth() + 1) + "-01"
        );
        this.Readytime1 =
          date.getFullYear() +
          "-" +
          this.zero(date.getMonth() + 1) +
          "-" +
          this.zero(date.getDate());
        this.changeTime(
          now.getFullYear() + "-" + this.zero(now.getMonth() + 1) + "-01"
        );
      } else if (val == 3) {
        let date = new Date(now.getFullYear() + "-01-01");
        this.Readytime1 =
          date.getFullYear() +
          "-" +
          this.zero(date.getMonth() + 1) +
          "-" +
          this.zero(date.getDate());
        this.changeTime(now.getFullYear() + "-01-01");
      }
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    show(id, type) {
      this.img = id;
      if (type == "video") {
        this.dialogVideo = true;
      } else if (type == "photo") {
        this.dialogImg = true;
      }
    },
    closeImg() {
      this.dialogImg = false;
      this.dialogVideo = false;
    },
    handler(row) {
      // this.status = row.status;
      // this.typeName = '';
      // this.deptName = '',
      this.tableId = row.id;
      // SpotCheck.getCheckResultsById({
      // 	id: this.tableId,
      // 	positionCode:''
      // }).then((response) => {
      // 	const data = response.data;
      // 	if (data.code == "1") {
      // 		this.tableDataTree = data.data
      // 		if (this.tableDataTree.checkEndTime != null && this.tableDataTree.checkBeginTime != null) {
      // 			let checkEndTime = new Date(this.tableDataTree.checkEndTime).getTime();
      // 			let checkBeginTime = new Date(this.tableDataTree.checkBeginTime).getTime();
      // 			let date = checkEndTime - checkBeginTime; //时间差的毫秒数
      // 			// //计算相差分钟数
      // 			// let leave2 = date % (3600 * 1000) //计算小时数后剩余的毫秒数
      // 			// let minutes = Math.floor(leave2 / (60 * 1000))<10?'0'+Math.floor(leave2 / (60 * 1000)):Math.floor(leave2 / (60 * 1000))
      // 			// //计算相差秒数
      // 			// let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
      // 			// let seconds = Math.round(leave3 / 1000)<10?'0'+Math.round(leave3 / 1000):Math.round(leave3 / 1000)
      // 			// this.tableDataTreeInfo.time1= minutes;
      // 			// this.tableDataTreeInfo.time2= seconds;
      // 			let endTime = new Date(this.tableDataTree.endTime).getTime();
      // 			let beginTime = new Date(this.tableDataTree.beginTime).getTime();

      // 			//计划时间
      // 			let date3 = endTime - beginTime;
      // 			// //计算相差分钟数
      // 			// let minutes2 = Math.floor(date3 / (60 * 1000))<10?'0'+Math.floor(date3 / (60 * 1000)):Math.floor(date3 / (60 * 1000))
      // 			// //计算相差秒数
      // 			// let leave5 = date3 % (60 * 1000) //计算分钟数后剩余的毫秒数
      // 			// let seconds2 = Math.round(leave5 / 1000)<10?'0'+Math.round(leave5 / 1000):Math.round(leave5 / 1000)
      // 			// this.tableDataTreeInfo.time3= minutes2;
      // 			// this.tableDataTreeInfo.time4= seconds2;
      // 			if (checkBeginTime > endTime) {
      // 				//实际点检时间 ok
      // 				this.styleObject4.width = '66%'
      // 				this.styleObject5.width = '0%'
      // 				//计划点检时间
      // 				this.styleObject6.width = '0%'
      // 				this.styleObject7.width = '66%'

      // 				this.styleObject1.width = '50%'
      // 				this.styleObject2.width = '50%'
      // 				this.styleObject3.width = '0%'
      // 			} else if (beginTime < checkBeginTime && checkEndTime > endTime) {
      // 				let a = ((checkBeginTime - beginTime) / date3) * 0.8 * 100
      // 				let b = ((endTime - checkEndTime) / date3)
      // 				//实际点检时间
      // 				this.styleObject4.width = (a < 0 ? 0 : a) + '%'
      // 				this.styleObject5.width = '0%'
      // 				//计划点检时间
      // 				this.styleObject6.width = '0%'
      // 				this.styleObject7.width = '20%'

      // 				this.styleObject1.width = (a < 0 ? 0 : a) + '%'
      // 				this.styleObject2.width = (100 - (a < 0 ? 0 : a)) + '%'
      // 				this.styleObject3.width = '0%'
      // 			} else if (beginTime > checkBeginTime && checkEndTime > endTime) {
      // 				//实际点检时间
      // 				this.styleObject4.width = '0%'
      // 				this.styleObject5.width = '0%'
      // 				//计划点检时间
      // 				this.styleObject6.width = '20%'
      // 				this.styleObject7.width = '20%'

      // 				this.styleObject1.width = '0%'
      // 				this.styleObject2.width = '100%'
      // 				this.styleObject3.width = '0%'
      // 			} else if (beginTime > checkBeginTime && checkEndTime < endTime) {
      // 				let b = ((endTime - checkEndTime) / date3) * 0.8 * 100
      // 				//实际点检时间
      // 				this.styleObject4.width = '0%'
      // 				this.styleObject5.width = b + '%'
      // 				//计划点检时间
      // 				this.styleObject6.width = '20%'
      // 				this.styleObject7.width = '0%'

      // 				this.styleObject1.width = '0%'
      // 				this.styleObject2.width = (100 - b) + '%'
      // 				this.styleObject3.width = b + '%'
      // 			} else {
      // 				let a = ((checkBeginTime - beginTime) / date3) * 100
      // 				let b = ((endTime - checkEndTime) / date3) * 100
      // 				this.styleObject4.width = (a < 0 ? 0 : a) + '%'
      // 				this.styleObject5.width = (b < 0 ? 0 : b) + '%'
      // 				//计划点检时间
      // 				this.styleObject6.width = '0%'
      // 				this.styleObject7.width = '0%'

      // 				this.styleObject1.width = (a < 0 ? 0 : a) + '%'
      // 				this.styleObject2.width = (100 - (a < 0 ? 0 : a) - (b < 0 ? 0 : b)) + '%'
      // 				this.styleObject3.width = (b < 0 ? 0 : b) + '%'
      // 			}
      // 		} else {
      // 			//实际点检时间
      // 			this.styleObject4.paddingLeft = '0%'
      // 			this.styleObject5.paddingRight = '0%'
      // 			//计划点检时间
      // 			this.styleObject6.paddingLeft = '0%'
      // 			this.styleObject7.paddingRight = '0%'

      // 			this.styleObject1.width = '100%'
      // 			this.styleObject2.width = '0%'
      // 			this.styleObject3.width = '0%'
      // 		}

      // 	}
      // }).catch((response) => {
      // 	console.log(response)
      // })
    },
    // checkDefaultValue(value) {
    // 	let list = JSON.parse(value);
    // 	let text = '';
    // 	list.forEach(function(value, index2, array) {
    // 		if (value.check == "1") {
    // 			text += value.name + ','
    // 		}
    // 	});
    // 	return text.substring(0, text.length - 1)
    // },
    checkDefaultValue(value, inputType) {
      try {
        console.log(inputType);
        const list = JSON.parse(value);
        if (
          Array.isArray(list) &&
          list.length == 2 &&
          inputType == 3 &&
          !list.find(item => item.name) == ""
        ) {
          // 找到最小值（check为"0"）和最大值（check为"1"）
          const minObj = list.find(item => item.check === "0");
          const maxObj = list.find(item => item.check === "1");

          if (minObj && maxObj) {
            return `${minObj.name} - ${maxObj.name}`;
          }
        } else {
          let text = "";
          list.forEach(function(value, index2, array) {
            if (value.check == "1") {
              text += value.name + ",";
            }
          });
          return text.substring(0, text.length - 1);
        }
        //   return '--'; // 数据格式不符合预期时显示默认值
      } catch (error) {
        console.error("解析defaultValue出错:", error);
        return "--";
      }
    },
    checkText(type) {
      let typeText = type.toString();
      let data = this.checkList.filter(function(item) {
        return item.key == typeText;
      });
      if (data != "") {
        return data[0].val;
      }
    },
    saveRemark() {
      if (Object.keys(this.tableDataInfo).length > 0) {
        this.dialogSpotRemark = true;
        this.newType.id = this.tableDataInfo.id;
        this.newType.remark = this.tableDataInfo.remark;
      } else {
        this.$message({
          message: this.$t("msg_1"),
          type: "error"
        });
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.checkFlag && this.errIds.indexOf(row.id) >= 0) {
        return "warning-row";
      }
      return "";
    },
    check(checkStatus) {
      this.checkUser = checkStatus;
      // for (let i = 0; i < this.spotStatusNumList.length; i++) {
      // 	this.spotStatusNumList[i].check = true;
      // }
      (this.checkStatus = checkStatus), (this.checkTime = checkStatus);
      this.checkTimebtn(checkStatus);
      this.checkFlag = true;
      this.spotStatusNumList[0].check = false;
      this.spotStatusNumList[1].check = false;
      this.spotStatusNumList[2].check = true;
      this.spotStatusNumList[3].check = true;
      this.spotStatusNumList[4].check = true;
      this.spotStatusNumList[5].check = true;
      this.search({
        pageNum: 1,
        pageSize: 9999
      });
    },
    checkOff() {
      this.checkFlag = false;
      this.checkStatus = 0;
      this.checkUser = 0;
      this.checkTime = 0;
      this.checkTimebtn(0);
      this.spotStatusNumList[0].check = true;
      this.spotStatusNumList[1].check = true;
      this.spotStatusNumList[2].check = true;
      this.spotStatusNumList[3].check = true;
      this.spotStatusNumList[4].check = true;
      this.spotStatusNumList[5].check = true;
      this.search({
        pageNum: 1,
        pageSize: 10
      });
    },
    checkOne() {
      if (
        this.tableDataInfo != null &&
        Object.keys(this.tableDataInfo).length > 0
      ) {
        if (this.errIds.indexOf(this.tableDataInfo.id) >= 0) {
          this.$message({
            message: this.$t("msg_83"),
            type: "warning"
          });
          return;
        }

        this.$confirm(this.$t("label_62") + "?", this.$t("label_358"), {
          confirmButtonText: this.$t("label_100"),
          cancelButtonText: this.$t("btn_1"),
          type: "warning"
        })
          .then(() => {
            SpotCheck.check([this.tableDataInfo], this.checkUser)
              .then(response => {
                const data = response.data;
                if (data.code == "1") {
                  for (let i = 0; i < this.tableDataTreeTime.length; i++) {
                    if (this.tableDataTreeTime[i].id == this.tableDataInfo.id) {
                      this.tableDataTreeTime.splice(i, 1);
                    }
                  }
                  this.spotStatusNumList[this.tableDataInfo.status].num--;
                  this.tableDataTree = "";
                  this.tableDataInfo = {};
                  this.$message({
                    message: this.$t("msg_16"),
                    type: "success"
                  });
                }
              })
              .catch(response => {
                console.log(response);
              });
          })
          .catch(() => {});
      } else {
        this.$message({
          message: this.$t("msg_1"),
          type: "warning"
        });
      }
    },
    checkBack(checkUser) {
      if (
        this.tableDataInfo != null &&
        Object.keys(this.tableDataInfo).length > 0
      ) {
        console.log(this.tableDataInfo);
        if (checkUser == 2 && this.tableDataInfo.checkStatus != 3) {
          utils.messageAlert(
            this.$t("msg_34"),
            this.$t("label_358"),
            this.$t("label_100")
          );
          return;
        }
        if (checkUser == 1 && this.tableDataInfo.checkStatus != 2) {
          utils.messageAlert(
            this.$t("msg_35"),
            this.$t("label_358"),
            this.$t("label_100")
          );
          return;
        }
        this.$confirm(this.$t("msg_36"), this.$t("label_358"), {
          confirmButtonText: this.$t("label_100"),
          cancelButtonText: this.$t("btn_1"),
          type: "warning"
        })
          .then(() => {
            SpotCheck.checkBack([this.tableDataInfo], checkUser)
              .then(response => {
                const data = response.data;
                if (data.code == "1") {
                  this.$message({
                    message: this.$t("msg_20"),
                    type: "success"
                  });
                  this.search({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                  });
                }
              })
              .catch(response => {
                console.log(response);
              });
          })
          .catch(() => {});
      } else {
        this.$message({
          message: this.$t("msg_1"),
          type: "warning"
        });
      }
    },
    checkAll() {
      if (this.errIds.length > 0) {
        this.$message({
          message: this.$t("msg_84"),
          type: "warning"
        });
        return;
      }
      this.$confirm(this.$t("msg_37"), this.$t("label_358"), {
        confirmButtonText: this.$t("label_100"),
        cancelButtonText: this.$t("btn_1"),
        type: "warning"
      })
        .then(() => {
          SpotCheck.check(this.tableDataTreeTime, this.checkUser)
            .then(response => {
              const data = response.data;
              if (data.code == "1") {
                this.tableDataTreeTime = [];
                this.spotStatusNumList[0].num = 0;
                this.spotStatusNumList[1].num = 0;
                this.spotStatusNumList[2].num = 0;
                this.spotStatusNumList[3].num = 0;
                this.spotStatusNumList[4].num = 0;
                this.spotStatusNumList[5].num = 0;
                this.tableDataTree = "";
                this.tableDataInfo = {};
                this.$message({
                  message: this.$t("msg_16"),
                  type: "success"
                });
              }
            })
            .catch(response => {
              console.log(response);
            });
        })
        .catch(() => {});
    },
    newTypeSave() {
      this.saveLoading = true;
      SpotCheck.checkSaveRemark(this.newType)
        .then(response => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogSpotRemark = false;
            this.search({
              pageNum: 1,
              pageSize: this.pageSize
            });
          }
          this.saveLoading = false;
        })
        .catch(response => {
          console.log(response);
          this.saveLoading = false;
        });
    },
    handleClose() {
      this.dialogSpotResult = false;
      this.dialogSpotRemark = false;
    },
    checkResults() {
      if (this.tableId != null && this.tableId != "") {
        this.tableDataTree = {};
        SpotCheck.getCheckResultsById({
          id: this.tableId,
          positionCode: ""
        })
          .then(response => {
            const data = response.data;
            if (data.code == "1") {
              this.tableDataTree = data.data;
              if (
                this.tableDataTree.checkEndTime != null &&
                this.tableDataTree.checkBeginTime != null
              ) {
                let checkEndTime = new Date(
                  this.tableDataTree.checkEndTime
                ).getTime();
                let checkBeginTime = new Date(
                  this.tableDataTree.checkBeginTime
                ).getTime();
                let date = checkEndTime - checkBeginTime; //时间差的毫秒数
                // //计算相差分钟数
                // let leave2 = date % (3600 * 1000) //计算小时数后剩余的毫秒数
                // let minutes = Math.floor(leave2 / (60 * 1000))<10?'0'+Math.floor(leave2 / (60 * 1000)):Math.floor(leave2 / (60 * 1000))
                // //计算相差秒数
                // let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
                // let seconds = Math.round(leave3 / 1000)<10?'0'+Math.round(leave3 / 1000):Math.round(leave3 / 1000)
                // this.tableDataTreeInfo.time1= minutes;
                // this.tableDataTreeInfo.time2= seconds;
                let endTime = new Date(this.tableDataTree.endTime).getTime();
                let beginTime = new Date(
                  this.tableDataTree.beginTime
                ).getTime();

                //计划时间
                let date3 = endTime - beginTime;
                // //计算相差分钟数
                // let minutes2 = Math.floor(date3 / (60 * 1000))<10?'0'+Math.floor(date3 / (60 * 1000)):Math.floor(date3 / (60 * 1000))
                // //计算相差秒数
                // var leave5 = date3 % (60 * 1000) //计算分钟数后剩余的毫秒数
                // var seconds2 = Math.round(leave5 / 1000)<10?'0'+Math.round(leave5 / 1000):Math.round(leave5 / 1000)
                // this.tableDataTreeInfo.time3= minutes2;
                // this.tableDataTreeInfo.time4= seconds2;
                if (checkBeginTime > endTime) {
                  //实际点检时间 ok
                  this.styleObject4.width = "66%";
                  this.styleObject5.width = "0%";
                  //计划点检时间
                  this.styleObject6.width = "0%";
                  this.styleObject7.width = "66%";

                  this.styleObject1.width = "50%";
                  this.styleObject2.width = "50%";
                  this.styleObject3.width = "0%";
                } else if (
                  beginTime < checkBeginTime &&
                  checkEndTime > endTime
                ) {
                  var a = ((checkBeginTime - beginTime) / date3) * 0.8 * 100;
                  var b = (endTime - checkEndTime) / date3;
                  //实际点检时间
                  this.styleObject4.width = (a < 0 ? 0 : a) + "%";
                  this.styleObject5.width = "0%";
                  //计划点检时间
                  this.styleObject6.width = "0%";
                  this.styleObject7.width = "20%";

                  this.styleObject1.width = (a < 0 ? 0 : a) + "%";
                  this.styleObject2.width = 100 - (a < 0 ? 0 : a) + "%";
                  this.styleObject3.width = "0%";
                } else if (
                  beginTime > checkBeginTime &&
                  checkEndTime > endTime
                ) {
                  //实际点检时间
                  this.styleObject4.width = "0%";
                  this.styleObject5.width = "0%";
                  //计划点检时间
                  this.styleObject6.width = "20%";
                  this.styleObject7.width = "20%";

                  this.styleObject1.width = "0%";
                  this.styleObject2.width = "100%";
                  this.styleObject3.width = "0%";
                } else if (
                  beginTime > checkBeginTime &&
                  checkEndTime < endTime
                ) {
                  var b = ((endTime - checkEndTime) / date3) * 0.8 * 100;
                  //实际点检时间
                  this.styleObject4.width = "0%";
                  this.styleObject5.width = b + "%";
                  //计划点检时间
                  this.styleObject6.width = "20%";
                  this.styleObject7.width = "0%";

                  this.styleObject1.width = "0%";
                  this.styleObject2.width = 100 - b + "%";
                  this.styleObject3.width = b + "%";
                } else {
                  var a = ((checkBeginTime - beginTime) / date3) * 100;
                  var b = ((endTime - checkEndTime) / date3) * 100;
                  this.styleObject4.width = (a < 0 ? 0 : a) + "%";
                  this.styleObject5.width = (b < 0 ? 0 : b) + "%";
                  //计划点检时间
                  this.styleObject6.width = "0%";
                  this.styleObject7.width = "0%";

                  this.styleObject1.width = (a < 0 ? 0 : a) + "%";
                  this.styleObject2.width =
                    100 - (a < 0 ? 0 : a) - (b < 0 ? 0 : b) + "%";
                  this.styleObject3.width = (b < 0 ? 0 : b) + "%";
                }
              } else {
                //实际点检时间
                this.styleObject4.paddingLeft = "0%";
                this.styleObject5.paddingRight = "0%";
                //计划点检时间
                this.styleObject6.paddingLeft = "0%";
                this.styleObject7.paddingRight = "0%";

                this.styleObject1.width = "100%";
                this.styleObject2.width = "0%";
                this.styleObject3.width = "0%";
              }
            }
          })
          .catch(response => {
            console.log(response);
          });
        this.errIds.splice(this.errIds.indexOf(this.tableDataTree.id), 1);
        this.dialogSpotResult = true;
      } else {
        this.$message({
          message: this.$t("msg_1"),
          type: "warning"
        });
      }
    },
    handleClickTree(tab, event) {
      this.reloadTree();
      this.getTreeMes = "1";
      this.deviceDetailMes = {};
      this.search({
        pageNum: 1,
        pageSize: this.pageSize
      });
    },
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    handleCurrentChangeTreeTime(info) {
      this.tableDataInfo = info;
    },

    changeSelectMonth() {
      this.tableDataTreeEdit.monthD = "";
      for (const k in this.monthOptions) {
        if (this.tableDataTreeEdit.month === this.monthOptions[k]) {
          this.monthDOptions = this.monthOptionsObj[
            this.tableDataTreeEdit.month
          ];
        }
      }
    },
    changeTime(date) {
        // ✅ 加强判断：日期无效时，直接清空Readytime和Readytime1
      if (!date) {
        this.Readytime = [];
        this.Readytime1 = null;
        return;
      }
      if (this.checkTime == 1) {
        let now = new Date(date);
        let nowTime = now.getTime();
        let day = now.getDay() == 0 ? 7 : now.getDay();
        let oneDayTime = 24 * 60 * 60 * 1000;
        // 本周一时间戳
        let MondayTime = nowTime - (day - 1) * oneDayTime;
        // 本周日时间戳
        let SundayTime = nowTime + (7 - day) * oneDayTime;
        // 格式化时间
        let monday = new Date(MondayTime);
        let sunday = new Date(SundayTime);
        this.Readytime1 =
          monday.getFullYear() +
          "-" +
          this.zero(monday.getMonth() + 1) +
          "-" +
          this.zero(monday.getDate());
        // this.Readytime1_ = sunday.getFullYear() + "-" + this.zero(sunday.getMonth() + 1) + "-" + this.zero(sunday.getDate());
        this.Readytime = [
          monday.getFullYear() +
            "-" +
            this.zero(monday.getMonth() + 1) +
            "-" +
            this.zero(monday.getDate()),
          sunday.getFullYear() +
            "-" +
            this.zero(sunday.getMonth() + 1) +
            "-" +
            this.zero(sunday.getDate())
        ];
      } else if (this.checkTime == 2) {
        var date = new Date(date);
        //设置月份
        date.setMonth(date.getMonth() + 1);
        //获取本月的最后一天
        var cdate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
        //打印某年某月的最后一天
        this.Readytime = [
          this.Readytime1,
          cdate.getFullYear() +
            "-" +
            this.zero(cdate.getMonth() + 1) +
            "-" +
            this.zero(cdate.getDate())
        ];
      } else if (this.checkTime == 3) {
        this.Readytime = [
          this.Readytime1,
          this.Readytime1.substring(0, 5) + "12-31"
        ];
      }
    },
    search(param) {
      this.errIds = [];
      this.tableDataTree = "";
      this.tableDataInfo = {};
      this.tableDataTreeTime = [];
      //this.pageCount = 0;
      let status = [];
      for (var i = 0; i < this.spotStatusNumList.length; i++) {
        if (this.spotStatusNumList[i].check == true) {
          status.push(i);
        }
      }
        // 获取当前日期，格式为 YYYY-MM-DD
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const currentDate = `${year}-${month}-${day}`;

      var dataParam = {
        // beginTime: this.Readytime[0],
        // endTime: this.Readytime[1],
        code: this.code,
        eqName: this.eqName,
        status: status,
        type: this.deviceDetailMes.type,
        id: this.deviceDetailMes.id,
        checkStatus: this.checkStatus,
      };

        // 规则：只要 日筛选有值 OR 周/月/年筛选有值 → 走时间区间查询
       const hasDayTime = Array.isArray(this.Readytime) && this.Readytime.length === 2 && this.Readytime[0] && this.Readytime[1];
       const hasOtherTime = this.Readytime1 && this.Readytime1 !== "";

      if(hasDayTime || hasOtherTime){
        dataParam.beginTime = this.Readytime[0];
        dataParam.endTime = this.Readytime[1];
      } else {
        dataParam.time = currentDate;
            // 清空多余的时间参数，防止后端接收到undefined
        delete dataParam.beginTime;
        delete dataParam.endTime;
      }

      var newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      this.searchPage(newParam);
      this.searchStauts(newParam);
    },
    searchStauts(param) {
      SpotCheck.getCheckStatus2(param)
        .then(response => {
          const data = response.data;
          if (data.code == "1") {
            this.spotStatusNumList[0].num = data.data.status0;
            this.spotStatusNumList[1].num = data.data.status1;
            this.spotStatusNumList[2].num = data.data.status2;
            this.spotStatusNumList[3].num = data.data.status3;
            this.spotStatusNumList[4].num = data.data.status4;
            this.spotStatusNumList[5].num = data.data.status5;
          }
        })
        .catch(response => {
          console.log(response);
        });
    },
    searchPage(param) {
      SpotCheck.getCheckPage(param)
        .then(response => {
          const data = response.data;
          if (data.code == "1") {
            if (this.checkFlag) {
              for (let d of data.data.records) {
                if (d.abnormalFlag == 0) {
                  this.errIds.push(d.id);
                }
              }
            }
            this.tableDataTreeTime = data.data.records;
            this.pageSize = data.data.size;
            this.pageCount = data.data.total;
            this.pageNum = data.data.current;
            this.$refs.pageModel.setCurrent(this.pageNum);
          }
        })
        .catch(response => {
          console.log(response);
        });
    },
    getDeviceMes(data) {
      if (data.name == this.$t("label_272")) {
        this.deviceDetailMes = {};
        this.search({
          pageNum: 1,
          pageSize: this.pageSize
        });
      } else {
        this.deviceDetailMes = data;
        this.search({
          pageNum: 1,
          pageSize: this.pageSize
        });
      }
    },
    getcheckList() {
      file
        .getCheckList()
        .then(response => {
          const data = response.data;
          if (data.code == "1") {
            this.checkList = data.data;
          }
        })
        .catch(response => {
          console.log(response);
        });
    },
    getNowTime() {
      let zeroTime = new Date();
      let Months =
        zeroTime.getMonth() + 1 < 10
          ? "0" + (zeroTime.getMonth() + 1)
          : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
      let Dates =
        zeroTime.getDate() < 10 ? "0" + zeroTime.getDate() : zeroTime.getDate();
      let now = zeroTime.getFullYear() + "-" + Months + "-" + Dates;
      return now;
    },
    getBeforeTime() {
      var time = new Date().getTime() - 24 * 60 * 60 * 1000;
      let zeroTime = new Date(time);
      let Months =
        zeroTime.getMonth() + 1 < 10
          ? "0" + (zeroTime.getMonth() + 1)
          : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
      let Dates =
        zeroTime.getDate() < 10 ? "0" + zeroTime.getDate() : zeroTime.getDate();
      let now = zeroTime.getFullYear() + "-" + Months + "-" + Dates;
      return now;
    },
    calcDay(date, i) {
      let d = new Date(date).getTime() + 1000 * 60 * 60 * 24 * i;
      date = new Date(d);
      return (
        date.getFullYear() +
        "-" +
        this.zero(date.getMonth() + 1) +
        "-" +
        this.zero(date.getDate())
      );
    },
    zero(i) {
      return i > 9 ? i : "0" + i;
    },
    showBtn() {
      this.qrCodeShow = !this.qrCodeShow;
      if (this.qrCodeShow) {
        this.width = "0px";
      } else {
        this.width = "340px";
      }
    },
    checkAllExportExcel() {
      let status = [];
      for (var i = 0; i < this.spotStatusNumList.length; i++) {
        if (this.spotStatusNumList[i].check == true) {
          status.push(i);
        }
      }
      let dataParam = {
        beginTime: this.Readytime[0],
        endTime: this.Readytime[1],
        code: this.code,
        eqName: this.eqName,
        status: status,
        type: this.deviceDetailMes.type,
        id: this.deviceDetailMes.id,
        checkStatus: this.checkStatus
      };
      SpotCheck.checkAllExportExcel(dataParam).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        let link = document.createElement("a");
        link.href = url;
        link.download = decodeURIComponent(
          response.headers["content-disposition"].split("fileName=")[1]
        );
        link.click();
        URL.revokeObjectURL(url);
      });
    },
    download() {
      if (this.tableId != null && this.tableId != "") {
        utils.startLoading();
        let dataParam = {
          id: this.tableId,
          positionCode: ""
        };
        SpotCheck.checkResultExcel(dataParam)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            let link = document.createElement("a");
            link.href = url;
            link.download = decodeURIComponent(
              response.headers["content-disposition"].split("fileName=")[1]
            );
            link.click();
            URL.revokeObjectURL(url);
            utils.endLoading();
          })
          .catch(err => {
            console.log("请求出错");
            utils.endLoading();
          });
      } else {
        this.$message({
          message: this.$t("msg_1"),
          type: "warning"
        });
      }
    }
  },
  created() {
    this.checkTimebtn(0);
    // this.Readytime = [this.getNowTime(), this.getBeforeTime()];
    // this.weekChange(this.calcDay(this.Readytime[0], -7));
    // let now = new Date();
    // now.setMonth(now.getMonth() - 1);
    // this.Readytime2 = now.getFullYear() + "-" + this.zero(now.getMonth() + 1);
    this.getcheckList();
    this.search({
      pageNum: 1,
      pageSize: this.pageSize
    });
    this.MenuRoleList = this.$store.getters.getMenu;
    this.$set(this.monthOptionsObj, this.$t("label_245"), [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10"
    ]);
    this.$set(this.monthOptionsObj, this.$t("label_242"), [
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20"
    ]);
    this.$set(this.monthOptionsObj, this.$t("label_238"), [
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31"
    ]);
  }
};
</script>

<style>
#dialogImg .el-dialog {
  height: 600px;
}

#dialogImg .el-dialog__body {
  height: 546px;
  overflow: auto;
  padding: 0;
}

.el-table .warning-row {
  background: #ffc5c5;
}
.timeRadio .el-radio-button__inner {
  padding: 12px 12px;
}
.right-showbtn-qrcode-background {
  /* position: absolute; */
  width: 10px;
  height: 80px;
  background-color: #9c9c9c;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin: auto;
}

.right-showbtn {
  width: 10px;
  height: 100%;
  display: flex;
  position: relative;
  z-index: 100000;
}
.email-dialog-content {
  max-height: 500px;
  overflow-y: auto;
}

.email-dialog-content .el-form-item {
  margin-bottom: 15px;
}

.email-dialog-content .el-table {
  font-size: 12px;
}

.email-dialog-content .el-table th {
  padding: 5px 0;
}

.email-dialog-content .el-table td {
  padding: 3px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/spotCheck/spotResumePage.vue